var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Headline',{attrs:{"level":1}},[_vm._v(" "+_vm._s(_vm.$t('components.oneMoment.message'))+" ")]),_vm._v(" "),_c('p',{staticClass:"flex items-center"},[_c('LoadingRing',{staticClass:"mr-4",attrs:{"size":24}}),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }